import config from "@/config/baseUrl.js"
import dayjs from "dayjs";
import { bus } from "@/utils/util.js";
import _ from "lodash"

class Socket {
    constructor() {
        this.socketStatus = false; // 连接状态
        this.heartTime = null; // 心跳记录时间戳
        this.heartColdDown = 3; // 心跳间隔时间/s
        this.heartBack = true; // 心跳数据返回
        this.socketClient = null;
    }
    // 创建连接
    create = _.debounce(() => {
        return new Promise(async (resolve, reject) => {
            // 如果已经连接了，直接返回
            if (this.socketStatus) return resolve();
            // 创建socket服务，连接服务
            this.socketClient = new WebSocket(config.wsUrl);
            // 连接上服务了
            this.socketClient.onopen = () => {
                this.socketStatus = true;
                this.heartBack = true;
                this.sendHeartbeat(); // 开始发送心跳信息，判断服务是否存活
                resolve();
            }
            // 连接报错
            this.socketClient.onerror = () => {
                this.socketStatus = false;
                reject();
                throw new Error("socket服务连接错误或异常，请检查");
            }
            // 消息接收，分类判断
            this.socketClient.onmessage = (msg) => {
                this.onMessage(msg)
            };
            // 断开
            this.socketClient.onclose = () => {
                this.socketStatus = false;
                console.log("socket服务连接已断开");
            }
        })
    }, 1000)
    // 心跳信息发送
    sendHeartbeat() {
        if (!this.socketStatus) {
            throw new Error("socket服务未连接");
        } else if (this.heartBack) {
            this.heartTime = dayjs().valueOf();
            this.heartBack = false;
            this.send({
                type: 999,
                data: this.heartTime
            }).then(() => {
                // 发送后开始记录，{heartColdDown}时间内如果没对应返回的信息，则代表服务器异常，重新发起连接
                let times = 0;
                const interval = setInterval(() => {
                    times++;
                    if (times % this.heartColdDown === 0 && !this.heartBack) {
                        this.close();
                        this.create();
                        clearInterval(interval);
                        throw new Error("socket服务心跳未返回，服务器异常，请检查");
                    }
                }, 1 * 1000);
            });
        }
    }
    // 消息推送
    async send(data) {
        return new Promise((resolve, reject) => {
            try {
                if (!this.socketStatus) return;
                this.socketClient.send(JSON.stringify(data));
                resolve();
            } catch {
                reject();
            }
        })
    }
    // 消息接收，分类判断
    onMessage(msg) {
        const { type, data } = JSON.parse(msg.data ?? "{}");
        // 心跳
        if (type === 999) {
            if (data !== this.heartTime) return;
            // 时间戳对应，5秒后重新发起心跳
            this.heartBack = true;
            const timeout = setTimeout(() => {
                this.sendHeartbeat();
                clearTimeout(timeout);
            }, this.heartColdDown * 1000);
            return;
        };
        bus.emit("socketMsg", { type, data });
    }
    // 断开连接
    close() {
        this.socketStatus = false;
        this.socketClient.close();
    }
}

export default Socket;